import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ENUM__settings_user_tab } from '../_base/ENUM__settings_user_tab';
import { S_TAB__user_wrapper } from '../_base/S_TAB__user_wrapper';
import UpdateAccountNameBlock from './InputUserName';
import UpdatePasswordBlock from './InputUserPassword';
import { S_BUTTON__logout } from './S_BUTTON__logout';
import S_VIEW__link_social_networks from './S_VIEW__link_social_networks';
import { S_VIEW__user_achievment } from './S_VIEW__user_achievment';
import S_VIEW__account_info from './ViewAccountInfo';

export function S_TAB__user_account() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { user_email } = use_slice_user(['user_email']);

  /*
   *
   */

  return (
    <S_TAB__user_wrapper type={ENUM__settings_user_tab.ACCOUNT}>
      <div className="mt-3 flex flex-col justify-start gap-5 w-full">
        <S_VIEW__user_achievment />

        <h3 className="text-xl mt-5">{t(i18n_page_settings_user.tabs.account.general_component.title)}</h3>
        <div className="w-full flex justify-start gap-10">
          <div className="flex flex-col justify-center items-center gap-5">
            <S_VIEW__account_info />
          </div>

          <div className="flex flex-col gap-8">
            <UpdateAccountNameBlock />
            <div className="flex items-center justify-start gap-3">
              <span className="w-[10rem]">{t(i18n_page_settings_user.tabs.account.general_component.account_email)}: </span>
              <span>{user_email}</span>
            </div>
            <UpdatePasswordBlock />
          </div>
        </div>
        <S_VIEW__link_social_networks />
        <S_BUTTON__logout />
      </div>
    </S_TAB__user_wrapper>
  );
}
